// Generated by `rushx icons:sync` from src/assets/icons/phosphor.json; do not edit.
/// <reference types="vite-svg-loader" />
/* eslint-disable simple-import-sort/imports -- icons:check compares this file byte for byte with what icons:sync writes */

import caretRightBoldIcon from "@phosphor-icons/core/bold/caret-right-bold.svg?component";
import layoutDuotoneIcon from "@phosphor-icons/core/duotone/layout-duotone.svg?component";
import minusCircleDuotoneIcon from "@phosphor-icons/core/duotone/minus-circle-duotone.svg?component";
import caretDownFillIcon from "@phosphor-icons/core/fill/caret-down-fill.svg?component";
import caretRightFillIcon from "@phosphor-icons/core/fill/caret-right-fill.svg?component";
import checkCircleFillIcon from "@phosphor-icons/core/fill/check-circle-fill.svg?component";
import infoFillIcon from "@phosphor-icons/core/fill/info-fill.svg?component";
import starFillIcon from "@phosphor-icons/core/fill/star-fill.svg?component";
import warningDiamondFillIcon from "@phosphor-icons/core/fill/warning-diamond-fill.svg?component";
import warningFillIcon from "@phosphor-icons/core/fill/warning-fill.svg?component";
import addressBookIcon from "@phosphor-icons/core/regular/address-book.svg?component";
import alignLeftSimpleIcon from "@phosphor-icons/core/regular/align-left-simple.svg?component";
import alignLeftIcon from "@phosphor-icons/core/regular/align-left.svg?component";
import arrowBendDoubleUpLeftIcon from "@phosphor-icons/core/regular/arrow-bend-double-up-left.svg?component";
import arrowBendLeftDownIcon from "@phosphor-icons/core/regular/arrow-bend-left-down.svg?component";
import arrowBendRightDownIcon from "@phosphor-icons/core/regular/arrow-bend-right-down.svg?component";
import arrowBendUpLeftIcon from "@phosphor-icons/core/regular/arrow-bend-up-left.svg?component";
import arrowBendUpRightIcon from "@phosphor-icons/core/regular/arrow-bend-up-right.svg?component";
import arrowCounterClockwiseIcon from "@phosphor-icons/core/regular/arrow-counter-clockwise.svg?component";
import arrowDownIcon from "@phosphor-icons/core/regular/arrow-down.svg?component";
import arrowElbowDownLeftIcon from "@phosphor-icons/core/regular/arrow-elbow-down-left.svg?component";
import arrowFatUpIcon from "@phosphor-icons/core/regular/arrow-fat-up.svg?component";
import arrowLeftIcon from "@phosphor-icons/core/regular/arrow-left.svg?component";
import arrowLineDownIcon from "@phosphor-icons/core/regular/arrow-line-down.svg?component";
import arrowLineLeftIcon from "@phosphor-icons/core/regular/arrow-line-left.svg?component";
import arrowLineRightIcon from "@phosphor-icons/core/regular/arrow-line-right.svg?component";
import arrowLineUpIcon from "@phosphor-icons/core/regular/arrow-line-up.svg?component";
import arrowSquareOutIcon from "@phosphor-icons/core/regular/arrow-square-out.svg?component";
import arrowUUpLeftIcon from "@phosphor-icons/core/regular/arrow-u-up-left.svg?component";
import arrowUpIcon from "@phosphor-icons/core/regular/arrow-up.svg?component";
import arrowsCounterClockwiseIcon from "@phosphor-icons/core/regular/arrows-counter-clockwise.svg?component";
import arrowsDownUpIcon from "@phosphor-icons/core/regular/arrows-down-up.svg?component";
import arrowsHorizontalIcon from "@phosphor-icons/core/regular/arrows-horizontal.svg?component";
import arrowsInLineHorizontalIcon from "@phosphor-icons/core/regular/arrows-in-line-horizontal.svg?component";
import arrowsInLineVerticalIcon from "@phosphor-icons/core/regular/arrows-in-line-vertical.svg?component";
import arrowsLeftRightIcon from "@phosphor-icons/core/regular/arrows-left-right.svg?component";
import arrowsOutLineHorizontalIcon from "@phosphor-icons/core/regular/arrows-out-line-horizontal.svg?component";
import arrowsOutLineVerticalIcon from "@phosphor-icons/core/regular/arrows-out-line-vertical.svg?component";
import articleNyTimesIcon from "@phosphor-icons/core/regular/article-ny-times.svg?component";
import atIcon from "@phosphor-icons/core/regular/at.svg?component";
import bankIcon from "@phosphor-icons/core/regular/bank.svg?component";
import barcodeIcon from "@phosphor-icons/core/regular/barcode.svg?component";
import batteryChargingIcon from "@phosphor-icons/core/regular/battery-charging.svg?component";
import bracketsSquareIcon from "@phosphor-icons/core/regular/brackets-square.svg?component";
import broomIcon from "@phosphor-icons/core/regular/broom.svg?component";
import browserIcon from "@phosphor-icons/core/regular/browser.svg?component";
import buildingApartmentIcon from "@phosphor-icons/core/regular/building-apartment.svg?component";
import buildingIcon from "@phosphor-icons/core/regular/building.svg?component";
import calculatorIcon from "@phosphor-icons/core/regular/calculator.svg?component";
import calendarBlankIcon from "@phosphor-icons/core/regular/calendar-blank.svg?component";
import cardsThreeIcon from "@phosphor-icons/core/regular/cards-three.svg?component";
import caretDoubleDownIcon from "@phosphor-icons/core/regular/caret-double-down.svg?component";
import caretDoubleRightIcon from "@phosphor-icons/core/regular/caret-double-right.svg?component";
import caretDoubleUpIcon from "@phosphor-icons/core/regular/caret-double-up.svg?component";
import caretDownIcon from "@phosphor-icons/core/regular/caret-down.svg?component";
import caretLeftIcon from "@phosphor-icons/core/regular/caret-left.svg?component";
import caretRightIcon from "@phosphor-icons/core/regular/caret-right.svg?component";
import caretUpIcon from "@phosphor-icons/core/regular/caret-up.svg?component";
import chartLineIcon from "@phosphor-icons/core/regular/chart-line.svg?component";
import checkCircleIcon from "@phosphor-icons/core/regular/check-circle.svg?component";
import checkIcon from "@phosphor-icons/core/regular/check.svg?component";
import circleDashedIcon from "@phosphor-icons/core/regular/circle-dashed.svg?component";
import circleIcon from "@phosphor-icons/core/regular/circle.svg?component";
import cityIcon from "@phosphor-icons/core/regular/city.svg?component";
import clipboardTextIcon from "@phosphor-icons/core/regular/clipboard-text.svg?component";
import clockIcon from "@phosphor-icons/core/regular/clock.svg?component";
import codeSimpleIcon from "@phosphor-icons/core/regular/code-simple.svg?component";
import codeIcon from "@phosphor-icons/core/regular/code.svg?component";
import columnsPlusLeftIcon from "@phosphor-icons/core/regular/columns-plus-left.svg?component";
import columnsPlusRightIcon from "@phosphor-icons/core/regular/columns-plus-right.svg?component";
import columnsIcon from "@phosphor-icons/core/regular/columns.svg?component";
import copyIcon from "@phosphor-icons/core/regular/copy.svg?component";
import cursorTextIcon from "@phosphor-icons/core/regular/cursor-text.svg?component";
import dotsSixVerticalIcon from "@phosphor-icons/core/regular/dots-six-vertical.svg?component";
import dotsSixIcon from "@phosphor-icons/core/regular/dots-six.svg?component";
import dotsThreeCircleIcon from "@phosphor-icons/core/regular/dots-three-circle.svg?component";
import dotsThreeVerticalIcon from "@phosphor-icons/core/regular/dots-three-vertical.svg?component";
import dotsThreeIcon from "@phosphor-icons/core/regular/dots-three.svg?component";
import downloadSimpleIcon from "@phosphor-icons/core/regular/download-simple.svg?component";
import dropIcon from "@phosphor-icons/core/regular/drop.svg?component";
import envelopeIcon from "@phosphor-icons/core/regular/envelope.svg?component";
import equalsIcon from "@phosphor-icons/core/regular/equals.svg?component";
import eyeSlashIcon from "@phosphor-icons/core/regular/eye-slash.svg?component";
import eyeIcon from "@phosphor-icons/core/regular/eye.svg?component";
import figmaLogoIcon from "@phosphor-icons/core/regular/figma-logo.svg?component";
import fileCsvIcon from "@phosphor-icons/core/regular/file-csv.svg?component";
import fileLockIcon from "@phosphor-icons/core/regular/file-lock.svg?component";
import fileMagnifyingGlassIcon from "@phosphor-icons/core/regular/file-magnifying-glass.svg?component";
import fileMinusIcon from "@phosphor-icons/core/regular/file-minus.svg?component";
import filePdfIcon from "@phosphor-icons/core/regular/file-pdf.svg?component";
import filePlusIcon from "@phosphor-icons/core/regular/file-plus.svg?component";
import filePptIcon from "@phosphor-icons/core/regular/file-ppt.svg?component";
import fileTxtIcon from "@phosphor-icons/core/regular/file-txt.svg?component";
import fileVideoIcon from "@phosphor-icons/core/regular/file-video.svg?component";
import fileXIcon from "@phosphor-icons/core/regular/file-x.svg?component";
import fileZipIcon from "@phosphor-icons/core/regular/file-zip.svg?component";
import fileIcon from "@phosphor-icons/core/regular/file.svg?component";
import flipHorizontalIcon from "@phosphor-icons/core/regular/flip-horizontal.svg?component";
import flipVerticalIcon from "@phosphor-icons/core/regular/flip-vertical.svg?component";
import floppyDiskIcon from "@phosphor-icons/core/regular/floppy-disk.svg?component";
import folderMinusIcon from "@phosphor-icons/core/regular/folder-minus.svg?component";
import folderPlusIcon from "@phosphor-icons/core/regular/folder-plus.svg?component";
import folderIcon from "@phosphor-icons/core/regular/folder.svg?component";
import funnelSimpleIcon from "@phosphor-icons/core/regular/funnel-simple.svg?component";
import funnelIcon from "@phosphor-icons/core/regular/funnel.svg?component";
import gearIcon from "@phosphor-icons/core/regular/gear.svg?component";
import globeIcon from "@phosphor-icons/core/regular/globe.svg?component";
import greaterThanOrEqualIcon from "@phosphor-icons/core/regular/greater-than-or-equal.svg?component";
import greaterThanIcon from "@phosphor-icons/core/regular/greater-than.svg?component";
import gridNineIcon from "@phosphor-icons/core/regular/grid-nine.svg?component";
import handDepositIcon from "@phosphor-icons/core/regular/hand-deposit.svg?component";
import hardDrivesIcon from "@phosphor-icons/core/regular/hard-drives.svg?component";
import hashIcon from "@phosphor-icons/core/regular/hash.svg?component";
import highlighterIcon from "@phosphor-icons/core/regular/highlighter.svg?component";
import houseIcon from "@phosphor-icons/core/regular/house.svg?component";
import imageSquareIcon from "@phosphor-icons/core/regular/image-square.svg?component";
import imageIcon from "@phosphor-icons/core/regular/image.svg?component";
import infoIcon from "@phosphor-icons/core/regular/info.svg?component";
import keyIcon from "@phosphor-icons/core/regular/key.svg?component";
import layoutIcon from "@phosphor-icons/core/regular/layout.svg?component";
import lessThanOrEqualIcon from "@phosphor-icons/core/regular/less-than-or-equal.svg?component";
import lessThanIcon from "@phosphor-icons/core/regular/less-than.svg?component";
import linkIcon from "@phosphor-icons/core/regular/link.svg?component";
import listBulletsIcon from "@phosphor-icons/core/regular/list-bullets.svg?component";
import listChecksIcon from "@phosphor-icons/core/regular/list-checks.svg?component";
import listNumbersIcon from "@phosphor-icons/core/regular/list-numbers.svg?component";
import listPlusIcon from "@phosphor-icons/core/regular/list-plus.svg?component";
import listIcon from "@phosphor-icons/core/regular/list.svg?component";
import lockSimpleOpenIcon from "@phosphor-icons/core/regular/lock-simple-open.svg?component";
import lockSimpleIcon from "@phosphor-icons/core/regular/lock-simple.svg?component";
import magnifyingGlassMinusIcon from "@phosphor-icons/core/regular/magnifying-glass-minus.svg?component";
import magnifyingGlassPlusIcon from "@phosphor-icons/core/regular/magnifying-glass-plus.svg?component";
import magnifyingGlassIcon from "@phosphor-icons/core/regular/magnifying-glass.svg?component";
import mapPinSimpleAreaIcon from "@phosphor-icons/core/regular/map-pin-simple-area.svg?component";
import microsoftExcelLogoIcon from "@phosphor-icons/core/regular/microsoft-excel-logo.svg?component";
import microsoftWordLogoIcon from "@phosphor-icons/core/regular/microsoft-word-logo.svg?component";
import minusCircleIcon from "@phosphor-icons/core/regular/minus-circle.svg?component";
import minusIcon from "@phosphor-icons/core/regular/minus.svg?component";
import networkIcon from "@phosphor-icons/core/regular/network.svg?component";
import notEqualsIcon from "@phosphor-icons/core/regular/not-equals.svg?component";
import notePencilIcon from "@phosphor-icons/core/regular/note-pencil.svg?component";
import notebookIcon from "@phosphor-icons/core/regular/notebook.svg?component";
import numberSquareFourIcon from "@phosphor-icons/core/regular/number-square-four.svg?component";
import numberSquareOneIcon from "@phosphor-icons/core/regular/number-square-one.svg?component";
import numberSquareThreeIcon from "@phosphor-icons/core/regular/number-square-three.svg?component";
import numberSquareTwoIcon from "@phosphor-icons/core/regular/number-square-two.svg?component";
import paintBucketIcon from "@phosphor-icons/core/regular/paint-bucket.svg?component";
import paletteIcon from "@phosphor-icons/core/regular/palette.svg?component";
import paperPlaneRightIcon from "@phosphor-icons/core/regular/paper-plane-right.svg?component";
import paperclipIcon from "@phosphor-icons/core/regular/paperclip.svg?component";
import pencilLineIcon from "@phosphor-icons/core/regular/pencil-line.svg?component";
import pencilSimpleLineIcon from "@phosphor-icons/core/regular/pencil-simple-line.svg?component";
import pencilSimpleIcon from "@phosphor-icons/core/regular/pencil-simple.svg?component";
import phoneIcon from "@phosphor-icons/core/regular/phone.svg?component";
import plugIcon from "@phosphor-icons/core/regular/plug.svg?component";
import plusCircleIcon from "@phosphor-icons/core/regular/plus-circle.svg?component";
import plusIcon from "@phosphor-icons/core/regular/plus.svg?component";
import printerIcon from "@phosphor-icons/core/regular/printer.svg?component";
import pushPinIcon from "@phosphor-icons/core/regular/push-pin.svg?component";
import questionIcon from "@phosphor-icons/core/regular/question.svg?component";
import rowsPlusBottomIcon from "@phosphor-icons/core/regular/rows-plus-bottom.svg?component";
import rowsPlusTopIcon from "@phosphor-icons/core/regular/rows-plus-top.svg?component";
import rowsIcon from "@phosphor-icons/core/regular/rows.svg?component";
import scissorsIcon from "@phosphor-icons/core/regular/scissors.svg?component";
import selectionAllIcon from "@phosphor-icons/core/regular/selection-all.svg?component";
import sigmaIcon from "@phosphor-icons/core/regular/sigma.svg?component";
import signInIcon from "@phosphor-icons/core/regular/sign-in.svg?component";
import signOutIcon from "@phosphor-icons/core/regular/sign-out.svg?component";
import sketchLogoIcon from "@phosphor-icons/core/regular/sketch-logo.svg?component";
import slidersHorizontalIcon from "@phosphor-icons/core/regular/sliders-horizontal.svg?component";
import sparkleIcon from "@phosphor-icons/core/regular/sparkle.svg?component";
import splitHorizontalIcon from "@phosphor-icons/core/regular/split-horizontal.svg?component";
import squareIcon from "@phosphor-icons/core/regular/square.svg?component";
import stackMinusIcon from "@phosphor-icons/core/regular/stack-minus.svg?component";
import stackOverflowLogoIcon from "@phosphor-icons/core/regular/stack-overflow-logo.svg?component";
import stackPlusIcon from "@phosphor-icons/core/regular/stack-plus.svg?component";
import stackIcon from "@phosphor-icons/core/regular/stack.svg?component";
import starIcon from "@phosphor-icons/core/regular/star.svg?component";
import suitcaseSimpleIcon from "@phosphor-icons/core/regular/suitcase-simple.svg?component";
import swapIcon from "@phosphor-icons/core/regular/swap.svg?component";
import tableIcon from "@phosphor-icons/core/regular/table.svg?component";
import textAlignCenterIcon from "@phosphor-icons/core/regular/text-align-center.svg?component";
import textAlignJustifyIcon from "@phosphor-icons/core/regular/text-align-justify.svg?component";
import textAlignLeftIcon from "@phosphor-icons/core/regular/text-align-left.svg?component";
import textAlignRightIcon from "@phosphor-icons/core/regular/text-align-right.svg?component";
import textBIcon from "@phosphor-icons/core/regular/text-b.svg?component";
import textColumnsIcon from "@phosphor-icons/core/regular/text-columns.svg?component";
import textHIcon from "@phosphor-icons/core/regular/text-h.svg?component";
import textIndentIcon from "@phosphor-icons/core/regular/text-indent.svg?component";
import textItalicIcon from "@phosphor-icons/core/regular/text-italic.svg?component";
import textOutdentIcon from "@phosphor-icons/core/regular/text-outdent.svg?component";
import textStrikethroughIcon from "@phosphor-icons/core/regular/text-strikethrough.svg?component";
import textSubscriptIcon from "@phosphor-icons/core/regular/text-subscript.svg?component";
import textSuperscriptIcon from "@phosphor-icons/core/regular/text-superscript.svg?component";
import textTSlashIcon from "@phosphor-icons/core/regular/text-t-slash.svg?component";
import textTIcon from "@phosphor-icons/core/regular/text-t.svg?component";
import textUnderlineIcon from "@phosphor-icons/core/regular/text-underline.svg?component";
import textboxIcon from "@phosphor-icons/core/regular/textbox.svg?component";
import timerIcon from "@phosphor-icons/core/regular/timer.svg?component";
import trashIcon from "@phosphor-icons/core/regular/trash.svg?component";
import treeStructureIcon from "@phosphor-icons/core/regular/tree-structure.svg?component";
import treeViewIcon from "@phosphor-icons/core/regular/tree-view.svg?component";
import uploadSimpleIcon from "@phosphor-icons/core/regular/upload-simple.svg?component";
import userCircleDashedIcon from "@phosphor-icons/core/regular/user-circle-dashed.svg?component";
import userGearIcon from "@phosphor-icons/core/regular/user-gear.svg?component";
import userPlusIcon from "@phosphor-icons/core/regular/user-plus.svg?component";
import userIcon from "@phosphor-icons/core/regular/user.svg?component";
import usersThreeIcon from "@phosphor-icons/core/regular/users-three.svg?component";
import usersIcon from "@phosphor-icons/core/regular/users.svg?component";
import warningCircleIcon from "@phosphor-icons/core/regular/warning-circle.svg?component";
import warningDiamondIcon from "@phosphor-icons/core/regular/warning-diamond.svg?component";
import warningIcon from "@phosphor-icons/core/regular/warning.svg?component";
import xCircleIcon from "@phosphor-icons/core/regular/x-circle.svg?component";
import xIcon from "@phosphor-icons/core/regular/x.svg?component";

export const PHOSPHOR_ICONS = {
  "phosphor/address-book": addressBookIcon,
  "phosphor/align-left": alignLeftIcon,
  "phosphor/align-left-simple": alignLeftSimpleIcon,
  "phosphor/arrow-bend-double-up-left": arrowBendDoubleUpLeftIcon,
  "phosphor/arrow-bend-left-down": arrowBendLeftDownIcon,
  "phosphor/arrow-bend-right-down": arrowBendRightDownIcon,
  "phosphor/arrow-bend-up-left": arrowBendUpLeftIcon,
  "phosphor/arrow-bend-up-right": arrowBendUpRightIcon,
  "phosphor/arrow-counter-clockwise": arrowCounterClockwiseIcon,
  "phosphor/arrow-down": arrowDownIcon,
  "phosphor/arrow-elbow-down-left": arrowElbowDownLeftIcon,
  "phosphor/arrow-fat-up": arrowFatUpIcon,
  "phosphor/arrow-left": arrowLeftIcon,
  "phosphor/arrow-line-down": arrowLineDownIcon,
  "phosphor/arrow-line-left": arrowLineLeftIcon,
  "phosphor/arrow-line-right": arrowLineRightIcon,
  "phosphor/arrow-line-up": arrowLineUpIcon,
  "phosphor/arrow-square-out": arrowSquareOutIcon,
  "phosphor/arrow-u-up-left": arrowUUpLeftIcon,
  "phosphor/arrow-up": arrowUpIcon,
  "phosphor/arrows-counter-clockwise": arrowsCounterClockwiseIcon,
  "phosphor/arrows-down-up": arrowsDownUpIcon,
  "phosphor/arrows-horizontal": arrowsHorizontalIcon,
  "phosphor/arrows-in-line-horizontal": arrowsInLineHorizontalIcon,
  "phosphor/arrows-in-line-vertical": arrowsInLineVerticalIcon,
  "phosphor/arrows-left-right": arrowsLeftRightIcon,
  "phosphor/arrows-out-line-horizontal": arrowsOutLineHorizontalIcon,
  "phosphor/arrows-out-line-vertical": arrowsOutLineVerticalIcon,
  "phosphor/article-ny-times": articleNyTimesIcon,
  "phosphor/at": atIcon,
  "phosphor/bank": bankIcon,
  "phosphor/barcode": barcodeIcon,
  "phosphor/battery-charging": batteryChargingIcon,
  "phosphor/brackets-square": bracketsSquareIcon,
  "phosphor/broom": broomIcon,
  "phosphor/browser": browserIcon,
  "phosphor/building": buildingIcon,
  "phosphor/building-apartment": buildingApartmentIcon,
  "phosphor/calculator": calculatorIcon,
  "phosphor/calendar-blank": calendarBlankIcon,
  "phosphor/cards-three": cardsThreeIcon,
  "phosphor/caret-double-down": caretDoubleDownIcon,
  "phosphor/caret-double-right": caretDoubleRightIcon,
  "phosphor/caret-double-up": caretDoubleUpIcon,
  "phosphor/caret-down": caretDownIcon,
  "phosphor/caret-down-fill": caretDownFillIcon,
  "phosphor/caret-left": caretLeftIcon,
  "phosphor/caret-right": caretRightIcon,
  "phosphor/caret-right-bold": caretRightBoldIcon,
  "phosphor/caret-right-fill": caretRightFillIcon,
  "phosphor/caret-up": caretUpIcon,
  "phosphor/chart-line": chartLineIcon,
  "phosphor/check": checkIcon,
  "phosphor/check-circle": checkCircleIcon,
  "phosphor/check-circle-fill": checkCircleFillIcon,
  "phosphor/circle": circleIcon,
  "phosphor/circle-dashed": circleDashedIcon,
  "phosphor/city": cityIcon,
  "phosphor/clipboard-text": clipboardTextIcon,
  "phosphor/clock": clockIcon,
  "phosphor/code": codeIcon,
  "phosphor/code-simple": codeSimpleIcon,
  "phosphor/columns": columnsIcon,
  "phosphor/columns-plus-left": columnsPlusLeftIcon,
  "phosphor/columns-plus-right": columnsPlusRightIcon,
  "phosphor/copy": copyIcon,
  "phosphor/cursor-text": cursorTextIcon,
  "phosphor/dots-six": dotsSixIcon,
  "phosphor/dots-six-vertical": dotsSixVerticalIcon,
  "phosphor/dots-three": dotsThreeIcon,
  "phosphor/dots-three-circle": dotsThreeCircleIcon,
  "phosphor/dots-three-vertical": dotsThreeVerticalIcon,
  "phosphor/download-simple": downloadSimpleIcon,
  "phosphor/drop": dropIcon,
  "phosphor/envelope": envelopeIcon,
  "phosphor/equals": equalsIcon,
  "phosphor/eye": eyeIcon,
  "phosphor/eye-slash": eyeSlashIcon,
  "phosphor/figma-logo": figmaLogoIcon,
  "phosphor/file": fileIcon,
  "phosphor/file-csv": fileCsvIcon,
  "phosphor/file-lock": fileLockIcon,
  "phosphor/file-magnifying-glass": fileMagnifyingGlassIcon,
  "phosphor/file-minus": fileMinusIcon,
  "phosphor/file-pdf": filePdfIcon,
  "phosphor/file-plus": filePlusIcon,
  "phosphor/file-ppt": filePptIcon,
  "phosphor/file-txt": fileTxtIcon,
  "phosphor/file-video": fileVideoIcon,
  "phosphor/file-x": fileXIcon,
  "phosphor/file-zip": fileZipIcon,
  "phosphor/flip-horizontal": flipHorizontalIcon,
  "phosphor/flip-vertical": flipVerticalIcon,
  "phosphor/floppy-disk": floppyDiskIcon,
  "phosphor/folder": folderIcon,
  "phosphor/folder-minus": folderMinusIcon,
  "phosphor/folder-plus": folderPlusIcon,
  "phosphor/funnel": funnelIcon,
  "phosphor/funnel-simple": funnelSimpleIcon,
  "phosphor/gear": gearIcon,
  "phosphor/globe": globeIcon,
  "phosphor/greater-than": greaterThanIcon,
  "phosphor/greater-than-or-equal": greaterThanOrEqualIcon,
  "phosphor/grid-nine": gridNineIcon,
  "phosphor/hand-deposit": handDepositIcon,
  "phosphor/hard-drives": hardDrivesIcon,
  "phosphor/hash": hashIcon,
  "phosphor/highlighter": highlighterIcon,
  "phosphor/house": houseIcon,
  "phosphor/image": imageIcon,
  "phosphor/image-square": imageSquareIcon,
  "phosphor/info": infoIcon,
  "phosphor/info-fill": infoFillIcon,
  "phosphor/key": keyIcon,
  "phosphor/layout": layoutIcon,
  "phosphor/layout-duotone": layoutDuotoneIcon,
  "phosphor/less-than": lessThanIcon,
  "phosphor/less-than-or-equal": lessThanOrEqualIcon,
  "phosphor/link": linkIcon,
  "phosphor/list": listIcon,
  "phosphor/list-bullets": listBulletsIcon,
  "phosphor/list-checks": listChecksIcon,
  "phosphor/list-numbers": listNumbersIcon,
  "phosphor/list-plus": listPlusIcon,
  "phosphor/lock-simple": lockSimpleIcon,
  "phosphor/lock-simple-open": lockSimpleOpenIcon,
  "phosphor/magnifying-glass": magnifyingGlassIcon,
  "phosphor/magnifying-glass-minus": magnifyingGlassMinusIcon,
  "phosphor/magnifying-glass-plus": magnifyingGlassPlusIcon,
  "phosphor/map-pin-simple-area": mapPinSimpleAreaIcon,
  "phosphor/microsoft-excel-logo": microsoftExcelLogoIcon,
  "phosphor/microsoft-word-logo": microsoftWordLogoIcon,
  "phosphor/minus": minusIcon,
  "phosphor/minus-circle": minusCircleIcon,
  "phosphor/minus-circle-duotone": minusCircleDuotoneIcon,
  "phosphor/network": networkIcon,
  "phosphor/not-equals": notEqualsIcon,
  "phosphor/note-pencil": notePencilIcon,
  "phosphor/notebook": notebookIcon,
  "phosphor/number-square-four": numberSquareFourIcon,
  "phosphor/number-square-one": numberSquareOneIcon,
  "phosphor/number-square-three": numberSquareThreeIcon,
  "phosphor/number-square-two": numberSquareTwoIcon,
  "phosphor/paint-bucket": paintBucketIcon,
  "phosphor/palette": paletteIcon,
  "phosphor/paper-plane-right": paperPlaneRightIcon,
  "phosphor/paperclip": paperclipIcon,
  "phosphor/pencil-line": pencilLineIcon,
  "phosphor/pencil-simple": pencilSimpleIcon,
  "phosphor/pencil-simple-line": pencilSimpleLineIcon,
  "phosphor/phone": phoneIcon,
  "phosphor/plug": plugIcon,
  "phosphor/plus": plusIcon,
  "phosphor/plus-circle": plusCircleIcon,
  "phosphor/printer": printerIcon,
  "phosphor/push-pin": pushPinIcon,
  "phosphor/question": questionIcon,
  "phosphor/rows": rowsIcon,
  "phosphor/rows-plus-bottom": rowsPlusBottomIcon,
  "phosphor/rows-plus-top": rowsPlusTopIcon,
  "phosphor/scissors": scissorsIcon,
  "phosphor/selection-all": selectionAllIcon,
  "phosphor/sigma": sigmaIcon,
  "phosphor/sign-in": signInIcon,
  "phosphor/sign-out": signOutIcon,
  "phosphor/sketch-logo": sketchLogoIcon,
  "phosphor/sliders-horizontal": slidersHorizontalIcon,
  "phosphor/sparkle": sparkleIcon,
  "phosphor/split-horizontal": splitHorizontalIcon,
  "phosphor/square": squareIcon,
  "phosphor/stack": stackIcon,
  "phosphor/stack-minus": stackMinusIcon,
  "phosphor/stack-overflow-logo": stackOverflowLogoIcon,
  "phosphor/stack-plus": stackPlusIcon,
  "phosphor/star": starIcon,
  "phosphor/star-fill": starFillIcon,
  "phosphor/suitcase-simple": suitcaseSimpleIcon,
  "phosphor/swap": swapIcon,
  "phosphor/table": tableIcon,
  "phosphor/text-align-center": textAlignCenterIcon,
  "phosphor/text-align-justify": textAlignJustifyIcon,
  "phosphor/text-align-left": textAlignLeftIcon,
  "phosphor/text-align-right": textAlignRightIcon,
  "phosphor/text-b": textBIcon,
  "phosphor/text-columns": textColumnsIcon,
  "phosphor/text-h": textHIcon,
  "phosphor/text-indent": textIndentIcon,
  "phosphor/text-italic": textItalicIcon,
  "phosphor/text-outdent": textOutdentIcon,
  "phosphor/text-strikethrough": textStrikethroughIcon,
  "phosphor/text-subscript": textSubscriptIcon,
  "phosphor/text-superscript": textSuperscriptIcon,
  "phosphor/text-t": textTIcon,
  "phosphor/text-t-slash": textTSlashIcon,
  "phosphor/text-underline": textUnderlineIcon,
  "phosphor/textbox": textboxIcon,
  "phosphor/timer": timerIcon,
  "phosphor/trash": trashIcon,
  "phosphor/tree-structure": treeStructureIcon,
  "phosphor/tree-view": treeViewIcon,
  "phosphor/upload-simple": uploadSimpleIcon,
  "phosphor/user": userIcon,
  "phosphor/user-circle-dashed": userCircleDashedIcon,
  "phosphor/user-gear": userGearIcon,
  "phosphor/user-plus": userPlusIcon,
  "phosphor/users": usersIcon,
  "phosphor/users-three": usersThreeIcon,
  "phosphor/warning": warningIcon,
  "phosphor/warning-circle": warningCircleIcon,
  "phosphor/warning-diamond": warningDiamondIcon,
  "phosphor/warning-diamond-fill": warningDiamondFillIcon,
  "phosphor/warning-fill": warningFillIcon,
  "phosphor/x": xIcon,
  "phosphor/x-circle": xCircleIcon,
};
